/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CategorySitemapEntry } from './';
import {
    CategorySitemapEntryFromJSON,
    CategorySitemapEntryFromJSONTyped,
    CategorySitemapEntryToJSON,
} from './';
import type { JobOrCategorySitemapEntry } from './';
import {
    JobOrCategorySitemapEntryFromJSON,
    JobOrCategorySitemapEntryFromJSONTyped,
    JobOrCategorySitemapEntryToJSON,
} from './';

/**
 * 
 * @export
 * @interface FamilySitemapEntry
 */
export interface FamilySitemapEntry {
    /**
     * 
     * @type {string}
     * @memberof FamilySitemapEntry
     */
    familyLabel: string;
    /**
     * 
     * @type {string}
     * @memberof FamilySitemapEntry
     */
    familyId?: string;
    /**
     * 
     * @type {string}
     * @memberof FamilySitemapEntry
     */
    url: string;
    /**
     * 
     * @type {Array<CategorySitemapEntry>}
     * @memberof FamilySitemapEntry
     */
    categorySitemapEntries?: Array<CategorySitemapEntry>;
    /**
     * 
     * @type {Array<JobOrCategorySitemapEntry>}
     * @memberof FamilySitemapEntry
     */
    jobOrCategorySitemapEntries?: Array<JobOrCategorySitemapEntry>;
}

/**
 * Check if a given object implements the FamilySitemapEntry interface.
 */
export function instanceOfFamilySitemapEntry(value: object): value is FamilySitemapEntry {
    if (!('familyLabel' in value) || value['familyLabel'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function FamilySitemapEntryFromJSON(json: any): FamilySitemapEntry {
    return FamilySitemapEntryFromJSONTyped(json, false);
}

export function FamilySitemapEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): FamilySitemapEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'familyLabel': json['familyLabel'],
        'familyId': json['familyId'] == null ? undefined : json['familyId'],
        'url': json['url'],
        'categorySitemapEntries': json['categorySitemapEntries'] == null ? undefined : ((json['categorySitemapEntries'] as Array<any>).map(CategorySitemapEntryFromJSON)),
        'jobOrCategorySitemapEntries': json['jobOrCategorySitemapEntries'] == null ? undefined : ((json['jobOrCategorySitemapEntries'] as Array<any>).map(JobOrCategorySitemapEntryFromJSON)),
    };
}

export function FamilySitemapEntryToJSON(value?: FamilySitemapEntry | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'familyLabel': value['familyLabel'],
        'familyId': value['familyId'],
        'url': value['url'],
        'categorySitemapEntries': value['categorySitemapEntries'] == null ? undefined : ((value['categorySitemapEntries'] as Array<any>).map((v) => CategorySitemapEntryToJSON(v))),
        'jobOrCategorySitemapEntries': value['jobOrCategorySitemapEntries'] == null ? undefined : ((value['jobOrCategorySitemapEntries'] as Array<any>).map((v) => JobOrCategorySitemapEntryToJSON(v))),
    };
}

